export enum FacetedSearch {
  NAME = 'faceted_search_slp_experiment',
  CONTROL_STANDARD_SEARCH = 'control',
  VARIANT_FACETED_SEARCH = 'variant',
}

export enum FacilitateFindability {
  NAME = 'facilitate_findability_of_products_experiment',
  CONTROL_HIDE_FEATURED_PRODUCT = 'control_hide_featured_product',
  VARIANT_SHOW_FEATURED_PRODUCT = 'variant_show_featured_product',
}

export enum BrowseProvider {
  NAME = 'browse_provider',
  GOOGLE = 'google_retail',
  LOOP54 = 'loop54',
}
